import { render, staticRenderFns } from "./activity-painting-contest_kr.vue?vue&type=template&id=375e8922&scoped=true&"
import script from "./activity-painting-contest_kr.vue?vue&type=script&lang=js&"
export * from "./activity-painting-contest_kr.vue?vue&type=script&lang=js&"
import style0 from "./activity-painting-contest_kr.vue?vue&type=style&index=0&id=375e8922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375e8922",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
